import { EventHelper } from '..';

export const useEvent = () => {
	let eventHelper = new EventHelper();
	return {
		eventHelper,
		activeEvent: eventHelper.active()
	};
};
